import axios from "axios";
import { REFRESH_TOKEN_KEY } from "../utils/constants";
import inMemoryJwt from "../Application/Auth/inMemoryJwt";

const API_URL = process.env.REACT_APP_DOMAIN;

export const api = axios.create({
  baseURL: `${API_URL}/api/admin`,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
    "api-version": "1.4",
  },
});

api.interceptors.request.use((config) => {
  const token = inMemoryJwt.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
    (res) => res.data,
    async (error) => {
      const status = error.response?.status;
      const originalRequest = error.config;

      if (status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);

        if (refreshToken) {
          try {
            await inMemoryJwt.refreshAccessToken();

            originalRequest.headers.Authorization = `Bearer ${inMemoryJwt.getToken()}`;
            return api(originalRequest);
          } catch {
            inMemoryJwt.ereaseToken();
            window.location.href = "/#/login";
            return Promise.reject(error);
          }
        } else {
          inMemoryJwt.ereaseToken();
          window.location.href = "/#/login";
        }
      }

      return Promise.reject(error);
    }
);